// carousel home
var swiper = new Swiper(".gift-swiper-cards ", {
    slidesPerView: 1,
    autoplay: true,
    loop: true,
    speed: 1000,

    pagination: {
        el: ".swiper-pagination",
    },
    breakpoints: {
        576: {
            slidesPerView: 2,
            spaceBetween: 10,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
        },
        992: {
            slidesPerView: 3,
            spaceBetween: 16,
        },
    },
});
// carousel product
var swiper = new Swiper(".PR-event ", {
    slidesPerView: 3,
    spaceBetween: 10,
    autoplay: true,
    loop: true,
    speed: 1000,
    pagination: {
        el: ".swiper-pagination",
    },
    breakpoints: {
        576: {
            slidesPerView: 4,
            spaceBetween: 14,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
        },
    },
});

// Active menu
const currentLocation = location.href;
const menuItem = document.querySelectorAll(".nav-item .nav-link");
const menuLength = menuItem.length;
for (let i = 0; i < menuLength; i++) {
    if (menuItem[i].href === currentLocation) {
        menuItem[i].className = "active";
    }
}
// SCROOL HIDE MENU TOP
window.onscroll = function() {
    scrollFunction();
};

function scrollFunction() {
    if (
        document.body.scrollTop > 100 ||
        document.documentElement.scrollTop > 100
    ) {
        document.getElementById("header_top").style.display = "none";
    } else {
        document.getElementById("header_top").style.display = "block";
    }
}
// Active categories List
function activeWhenClick() {
    $(".categories-list ul li").on("click", function() {
        $(".categories-list ul li").removeClass("active");
        $(this).addClass("active");
    });
    $(".gift-icons .icon-service").on("click", function() {
        $(".gift-icons .icon-service").removeClass("active");
        $(this).addClass("active");
    });
    $(".list-card-products .card-price").on("click", function() {
        $(".list-card-products .card-price").removeClass("active");
        $(this).addClass("active");
    });
    $(".items-flex .item-delivery").on("click", function() {
        $(".items-flex .item-delivery").removeClass("active");
        $(this).addClass("active");
    });
    $(".items-flex-right .item-delivery").on("click", function() {
        $(".items-flex-right .item-delivery").removeClass("active");
        $(this).addClass("active");
    });
    // OPEN POPUP PICTURE
    $("#openPopupPicture").on("click", function() {
        $(".gift-box .popup-picture").addClass("active");
        $(".gift-box .popup-overlay").addClass("active");
    });
    // CLOSE POPUP PICTURE
    $(".btn-close-picture").on("click", function() {
        $(".gift-box .popup-picture").removeClass("active");
        $(".gift-box .popup-overlay").removeClass("active");
    });
    $(".gift-box .popup-overlay").on("click", function() {
        $(".gift-box .popup-picture").removeClass("active");
        $(".gift-box .popup-overlay").removeClass("active");
    });
}

$(document).ready(function() {
    activeWhenClick();
});

// UPLOAD IMAGE
const defaultBtn = document.querySelector("#default-btn");
const customBtn = document.querySelector("#custom-btn");
const imgUpload = document.querySelector("#show-img-upload");
const fileNameUpload = document.querySelector(".status");
let regExp = /[0-9a-zA-Z\^\&\'\@\{\}\[\]\,\$\=\!\-\#\(\)\.\%\+\~\_ ]+$/;

function defaultBtnActive() {
    defaultBtn.click();
}
defaultBtn.addEventListener("change", function() {
    const file = this.files[0];
    if (file) {
        const reader = new FileReader();
        reader.onload = function() {
            const result = reader.result;
            imgUpload.src = result;
        };
        reader.readAsDataURL(file);
    }
    if (this.value) {
        let valueStore = this.value.match(regExp);
        fileNameUpload.textContent = valueStore;
    }
});